const userAgent = browser => {
  return navigator.userAgent.includes(browser);
};

export const isChromeAgent = userAgent('Chrome');
export const isFirefoxAgent = userAgent('Firefox');
